import Vue from 'vue'
import { URL_DICTIONARIES } from '@/constants/urls.js'
import { DICTIONARIES, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [DICTIONARIES.STATE.COUNTRIES]: null,
  [DICTIONARIES.STATE.PRODUCT_SECTIONS]: null,
  [DICTIONARIES.STATE.INCOTERMS]: null,
  [DICTIONARIES.STATE.DELIVERY_BASISES]: null
}

const actions = {
  async [DICTIONARIES.ACTIONS.GET_IDENTITY_DICTIONARY_ITEMS] ({ dispatch, commit }, model) {
    const { dictionaryType } = model
    delete model.dictionaryType
    model.url = `${Vue.getIdentityHost()}${URL_DICTIONARIES}/${dictionaryType}?${Vue.helpers.getQueryParamsString(model)}`

    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(DICTIONARIES.MUTATIONS.GET_DICTIONARY_ITEMS, { dictionaryType, items: resp.data })
  },
  async [DICTIONARIES.ACTIONS.GET_BUSINESS_DICTIONARY_ITEMS] ({ dispatch, commit }, model) {
    const { dictionaryType } = model
    delete model.dictionaryType
    model.url = `${Vue.getBusinessHost()}${URL_DICTIONARIES}/${dictionaryType}?${Vue.helpers.getQueryParamsString(model)}`

    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(DICTIONARIES.MUTATIONS.GET_DICTIONARY_ITEMS, { dictionaryType, items: resp.data })
  },
  async [DICTIONARIES.ACTIONS.CLEAR_DICTIONARY_ITEMS] ({ commit }, dictionaryType) {
    commit(DICTIONARIES.MUTATIONS.CLEAR_DICTIONARY_ITEMS, dictionaryType)
  }
}

const mutations = {
  [DICTIONARIES.MUTATIONS.GET_DICTIONARY_ITEMS] (state, model) {
    state[model.dictionaryType] = model.items
  },
  [DICTIONARIES.MUTATIONS.CLEAR_DICTIONARY_ITEMS] (state, dictionaryType) {
    state[dictionaryType] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
